import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { Button, Dialog, FakeText, TextField } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import RequiredDocTypeComponentItem from './RequiredDocTypeComponentItem';
import { DocumentLoadingContainer, RequiredDocumentsActionsContainer } from './AttachmentStyles';

const RequiredDocTypeComponent = ({
  requiredDocTypes,
  loading,
  adding,
  filter,
  hasSelection,
  onSetFilter,
  onCloseModal,
  onToggleSelectItem,
  onAddAttachments,
  backDropClick
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='required-doc-type-dialog'
      open
      fullWidth
      maxWidth={'md'}
      onClose={backDropClick}
      title={t('Offer.Edit.AttachmentsData.Documents')}
      content={
        <Grid container justifyContent={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <TextField
              placeholder={t('Offer.Edit.AttachmentsData.SearchDocument')}
              fullWidth={true}
              name='requiredDocTypes_filter'
              value={filter}
              onChange={onSetFilter}
            />
          </Grid>

          {loading && (
            <DocumentLoadingContainer>
              <FakeText lines={8} />
            </DocumentLoadingContainer>
          )}

          {!loading && (
            <Table id={'requiredDocTypes_list'}>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>{t('Offer.Edit.AttachmentsData.DocumentName')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('Offer.Edit.AttachmentsData.Context')}</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {requiredDocTypes.map((docType, index) => (
                  <RequiredDocTypeComponentItem key={index} item={docType} onToggleSelectItem={onToggleSelectItem} />
                ))}
              </TableBody>
            </Table>
          )}
        </Grid>
      }
      actions={
        <RequiredDocumentsActionsContainer>
          <Button onClick={onAddAttachments} disabled={!hasSelection || adding}>
            {adding ? t('General.Adding') : t('General.Add')}
          </Button>
          <Button onClick={onCloseModal}>{t('General.Close')}</Button>
        </RequiredDocumentsActionsContainer>
      }
    />
  );
};

RequiredDocTypeComponent.propTypes = {
  requiredDocTypes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  adding: PropTypes.bool.isRequired,
  filter: PropTypes.string.isRequired,
  hasSelection: PropTypes.bool.isRequired,
  onSetFilter: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onToggleSelectItem: PropTypes.func.isRequired,
  onAddAttachments: PropTypes.func.isRequired,
  backDropClick: PropTypes.func.isRequired
};

export default RequiredDocTypeComponent;
